import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    auth: {
      affiliate_unsubscribe: {
        want_to_unsubscribe: 'WANT_TO_UNSUBSCRIBE',
        have_been_unsubscribed: 'HAVE_BEEN_UNSUBSCRIBED',
        unsubscribe_button: 'UNSUBSCRIBE_BUTTON',
      },
    },
  }));
}
